import { render, staticRenderFns } from "./legal-info.vue?vue&type=template&id=ec6f01d8&scoped=true"
import script from "./legal-info.vue?vue&type=script&lang=js"
export * from "./legal-info.vue?vue&type=script&lang=js"
import style0 from "./legal-info.vue?vue&type=style&index=0&id=ec6f01d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6f01d8",
  null
  
)

export default component.exports